import {
  Component,
  OnInit,
  HostListener,
  Inject,
  PLATFORM_ID
} from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Stockitem } from '../../../../interfaces/stockitem';
import { AdvancedStocksService } from '../../../../services/advancedstocksservice';
import { DeviceDetectorService } from '../../../../services/device-detector.service';
import { isPlatformBrowser } from '@angular/common';

@Component({
  selector: 'app-productsbybrand',
  templateUrl: './productsbybrand.component.html',
  styleUrl: './productsbybrand.component.scss'
})
export class ProductsbybrandComponent implements OnInit {

  allData: Stockitem[] = [];
  totalItems = 0;
  stockTotal: any;
  activeCategory: number | null = null;
  activeLimit: number | null = null;
  contentReady = true;
  noData = false;
  searched = false;

  page = 1;
  itemCount = 9;

  isAr = false;
  isMobile = false;
  bybrand = true;

  brandId!: any;
  catagoryId?: any;
  price?: any;

  private isBrowser: boolean;

  constructor(
    private router: Router,
    private _advancedStocks: AdvancedStocksService,
    private deviceService: DeviceDetectorService,
    private route: ActivatedRoute,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  ngOnInit(): void {

    // ⛔ SSR يقف هنا
    if (!this.isBrowser) {
      return;
    }

    // Browser only
    this.isMobile = this.deviceService.isMobileDevice();
    this.itemCount = this.isMobile ? 8 : 9;
    this.isAr = localStorage.getItem('language') === 'ar';

    this.route.params.subscribe(params => {
      this.brandId = params['id'];
      if (this.brandId) {
        this.page = 1;
        this.getProductsByBrand();
      }
    });
  }

  selectCategory(category: number | null): void {
    this.activeCategory = category;
    this.getProductsByPetAndCatagory(category);
  }

  selectLimit(limit: number): void {
    this.activeLimit = limit;
    this.underPrice(limit);
  }
  // ================= FILTERS =================
  underPrice(price: any): void {
    this.price = price;
    this.page = 1;
    this.getProductsByBrand(true);
  }

  getProductsByPetAndCatagory(catagoryId: any): void {
    this.catagoryId = catagoryId;
    this.page = 1;
    this.getProductsByBrand(true);
  }

  // ================= DATA =================
  getProductsByBrand(reset = false): void {

    if (reset) {
      this.allData = [];
      this.page = 1;
    }

    this.contentReady = true;
    this.searched = false;

    this._advancedStocks
      .advancedStocks(
        1,
        this.page,
        this.itemCount,
        {
          brandId: this.brandId,
          categoryId: this.catagoryId,
          maxPrice: this.price
        }
      )
      .subscribe({
        next: (res: any) => {
          this.allData = res.data;
          this.stockTotal = res.meta.total;
          this.totalItems = res.meta.last_page;

          this.noData = this.stockTotal === 0;
          this.contentReady = false;

          // scroll → browser only
          if (this.isBrowser) {
            window.scrollTo({ top: 0, behavior: 'smooth' });
          }
        },
        error: (error) => {
          console.error(error);
          this.contentReady = false;
          this.noData = true;
        },
      });
  }

  // ================= INFINITE SCROLL =================
  @HostListener('window:scroll', [])
  onWindowScroll(): void {

    if (!this.isBrowser || this.contentReady) return;

    const scrollPosition =
      window.pageYOffset ||
      document.documentElement.scrollTop ||
      document.body.scrollTop ||
      0;

    const windowHeight = window.innerHeight;
    const pageHeight = document.documentElement.scrollHeight;

    const bottomReached =
      scrollPosition + windowHeight >= pageHeight - 10;

    if (this.page === 1) {
      this.page = 2;
    }

    if (bottomReached && this.page <= this.totalItems) {
      this.loadMore();
    }
  }

  private loadMore(): void {
    this.contentReady = true;

    this._advancedStocks
      .advancedStocks(
        1,
        this.page,
        this.itemCount,
        {
          brandId: this.brandId,
          categoryId: this.catagoryId,
          maxPrice: this.price
        }
      )
      .subscribe({
        next: (res: any) => {
          this.allData = [...this.allData, ...res.data];
          this.page++;
          this.noData = this.allData.length === 0;
          this.contentReady = false;
        },
        error: (error) => {
          console.error(error);
          this.contentReady = false;
        },
      });
  }

  // ================= NAVIGATION =================
  byPet(pet: any, petId: any): void {
    this.router.navigate(['/pet', pet, petId]);
  }
}
